(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facelift-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.facelift-hero').forEach(function (section) {
    var thumbs = section.querySelectorAll('[data-thumb]');
    var mainWrapper = section.querySelector('[data-main-image]');
    var mainImg = mainWrapper ? mainWrapper.querySelector('img') : null;
    if (thumbs.length && mainImg) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var url = thumb.getAttribute('data-image-url');
          if (url) {
            mainImg.src = url;
            mainImg.srcset = '';
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mudzyme-hero-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mud-magnify]').forEach(function (wrap) {
    var src = wrap.getAttribute('data-zoom-src');
    if (!src) return;
    var zoomLevel = 2.2;

    var pane = document.createElement('div');
    pane.className = 'mud-hero__magnifier-pane';
    pane.style.backgroundImage = 'url("' + src + '")';
    wrap.appendChild(pane);
    wrap._mudPane = pane;

    function setBgSize() {
      pane.style.backgroundSize = (wrap.offsetWidth * zoomLevel) + 'px ' + (wrap.offsetHeight * zoomLevel) + 'px';
    }

    wrap.addEventListener('mouseenter', function () {
      setBgSize();
      wrap.classList.add('is-zooming');
    });

    wrap.addEventListener('mousemove', function (e) {
      var rect = wrap.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;
      x = Math.max(0, Math.min(1, x));
      y = Math.max(0, Math.min(1, y));
      pane.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
    });

    wrap.addEventListener('mouseleave', function () {
      wrap.classList.remove('is-zooming');
    });
  });

  document.querySelectorAll('.mud-hero').forEach(function (hero) {
    var thumbs = hero.querySelectorAll('[data-mud-thumb]');
    if (!thumbs.length) return;
    var mainImg = hero.querySelector('.mud-hero__img');
    var wrap = hero.querySelector('[data-mud-magnify]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-image-url');
        var zoomUrl = thumb.getAttribute('data-zoom-url');
        if (mainImg && url) {
          mainImg.src = url;
          mainImg.removeAttribute('srcset');
        }
        if (wrap && zoomUrl) {
          wrap.setAttribute('data-zoom-src', zoomUrl);
          if (wrap._mudPane) {
            wrap._mudPane.style.backgroundImage = 'url("' + zoomUrl + '")';
          }
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mudzyme-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mudzyme-hero').forEach(function (section) {
    var thumbs = section.querySelectorAll('[data-thumb]');
    var mainWrapper = section.querySelector('[data-main-image]');
    var mainImg = mainWrapper ? mainWrapper.querySelector('img') : null;
    if (thumbs.length && mainImg) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var url = thumb.getAttribute('data-image-url');
          if (url) {
            mainImg.src = url;
            mainImg.srcset = '';
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mudzyme-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mud-sticky]').forEach(function (bar) {
    var selector = bar.getAttribute('data-target-selector') || '.mud-hero__form';
    var target = document.querySelector(selector);
    var footer = document.querySelector('footer')
      || document.querySelector('[class*="footer-group"]')
      || document.querySelector('.footer');

    var abortController = new AbortController();
    var signal = abortController.signal;

    // ── Fallback: no target found → use scroll pixel trigger ──
    if (!target) {
      var showAfter = parseInt(bar.getAttribute('data-show-after'), 10) || 600;
      function onScroll() {
        if (window.scrollY > showAfter) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true, signal: signal });
      onScroll();
      return;
    }

    // ── Preferred: IntersectionObserver on hero ATC + footer ──
    var atcAboveViewport = false;
    var footerVisible = false;

    function updateVisibility() {
      if (atcAboveViewport && !footerVisible) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }

    var atcObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;

      if (!entry.isIntersecting) {
        // Element not in viewport — check if it's above (scrolled past) or below (not yet)
        var rect = entry.target.getBoundingClientRect();
        atcAboveViewport = (rect.bottom < 0);
      } else {
        atcAboveViewport = false;
      }
      updateVisibility();
    });
    atcObserver.observe(target);

    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        footerVisible = entry.isIntersecting;
        updateVisibility();
      }, { rootMargin: '200px 0px 0px 0px' });
      footerObserver.observe(footer);
    }

    // Clean up observers if the sticky bar is ever removed from the DOM
    signal.addEventListener('abort', function () {
      atcObserver.disconnect();
      if (footer) footerObserver.disconnect();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prevent-remove-final"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pr-final__form').forEach(function (form) {
    var input = form.querySelector('[data-pr-qty-input]');
    var minus = form.querySelector('[data-pr-qty-minus]');
    var plus = form.querySelector('[data-pr-qty-plus]');
    if (!input) return;
    minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prevent-remove-hero-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pr-magnify]').forEach(function (wrap) {
    var src = wrap.getAttribute('data-zoom-src');
    if (!src) return;
    var zoomLevel = 2.2;

    var pane = document.createElement('div');
    pane.className = 'pr-hero__magnifier-pane';
    pane.style.backgroundImage = 'url("' + src + '")';
    wrap.appendChild(pane);

    function setBgSize() {
      pane.style.backgroundSize = (wrap.offsetWidth * zoomLevel) + 'px ' + (wrap.offsetHeight * zoomLevel) + 'px';
    }

    wrap.addEventListener('mouseenter', function () {
      setBgSize();
      wrap.classList.add('is-zooming');
    });

    wrap.addEventListener('mousemove', function (e) {
      var rect = wrap.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;
      x = Math.max(0, Math.min(1, x));
      y = Math.max(0, Math.min(1, y));
      pane.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
    });

    wrap.addEventListener('mouseleave', function () {
      wrap.classList.remove('is-zooming');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prevent-remove-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pr-hero').forEach(function (section) {
    var thumbs = section.querySelectorAll('[data-thumb]');
    var mainWrapper = section.querySelector('[data-main-image]');
    var mainImg = mainWrapper ? mainWrapper.querySelector('img') : null;
    if (thumbs.length && mainImg) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var url = thumb.getAttribute('data-image-url');
          if (url) {
            mainImg.src = url;
            mainImg.srcset = '';
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prevent-remove-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pr-sticky]').forEach(function (bar) {
    var showAfter = parseInt(bar.getAttribute('data-show-after'), 10) || 600;
    function onScroll() {
      if (window.scrollY > showAfter) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-nsb-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.nsb-hero').forEach(function (section) {
    var thumbs = section.querySelectorAll('[data-thumb]');
    var mainWrapper = section.querySelector('[data-main-image]');
    var mainImg = mainWrapper ? mainWrapper.querySelector('img') : null;
    if (thumbs.length && mainImg) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var url = thumb.getAttribute('data-image-url');
          if (url) {
            mainImg.src = url;
            mainImg.srcset = '';
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitac-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.vitac-hero').forEach(function (section) {
    var thumbs = section.querySelectorAll('[data-thumb]');
    var mainWrapper = section.querySelector('[data-main-image]');
    var mainImg = mainWrapper ? mainWrapper.querySelector('img') : null;
    if (thumbs.length && mainImg) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var url = thumb.getAttribute('data-image-url');
          if (url) {
            mainImg.src = url;
            mainImg.srcset = '';
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
